import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/auth.context";
import { BrowserRouter } from "react-router-dom";
import { ExchangeRateProvider } from "./contexts/exchangeRate.context";
import { FeatureVisibilityProvider } from "./contexts/featureVisibility.context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FeatureVisibilityProvider>
          <ExchangeRateProvider>
            <App />
          </ExchangeRateProvider>
        </FeatureVisibilityProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
